export default "__VITE_ASSET__CzDlQAUX__"